"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const core_1 = require("@angular/core");
const RoutingDisabler_service_1 = require("../../../@inax/common/src/routing/RoutingDisablerService/RoutingDisabler.service");
let TestPageComponent = class TestPageComponent {
    constructor(_routingDisablerService) {
        this._routingDisablerService = _routingDisablerService;
    }
    ngOnInit() {
    }
    toggleDisableRouting() {
        if (this._routingDisablerService.isDisabled) {
            this._routingDisablerService.enable("testlock");
        }
        else {
            this._routingDisablerService.disable("testlock");
        }
    }
};
TestPageComponent = __decorate([
    core_1.Component({
        selector: 'testpage',
        templateUrl: 'app/components/testpage/testpage.component.html',
        styleUrls: ['app/components/testpage/testpage.component.css']
    }),
    __metadata("design:paramtypes", [RoutingDisabler_service_1.RoutingDisablerService])
], TestPageComponent);
exports.TestPageComponent = TestPageComponent;
